module.exports = __webpack_public_path__ + "static/media/1_en.2b6a200b.png";